<template>
  <TermsPage type="career" name="Careers" :slug="$route.params.slug" />
</template>
